import { render, staticRenderFns } from "./coupon_center.vue?vue&type=template&id=7f237ab8&scoped=true"
import script from "./coupon_center.vue?vue&type=script&lang=js"
export * from "./coupon_center.vue?vue&type=script&lang=js"
import style0 from "./coupon_center.vue?vue&type=style&index=0&id=7f237ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f237ab8",
  null
  
)

export default component.exports